import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Spinner, Form, Modal } from 'react-bootstrap';
import ShoppingCartItem from './ShoppingCartItem';
import AddressesComponent from './AddressesComponent';
import { formatMoney } from '../../utils/formatMoney';
import { setShowShoppingCart } from '../../redux/modules/show';
import { apiUrl, mainApiUrl, businessName } from '../../utils/consts';
import ShoppingCartPayment from './ShoppingCartPayment';
import './styles/shoppingCart.scss';

const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

function mapDispatchToProps(dispatch) {
  return {
    setShowShoppingCart: show => dispatch(setShowShoppingCart(show))
  };
}

const select = state => {
  return {
    token: state.auth.token,
    userId: state.auth.userId,
    user: state.auth.user,
    showShoppingCart: state.show.showShoppingCart
  };
};

class ConnectedShoppingCart extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      products: [],
      userAddresses: [],
      selectedAddress: {},
      isLoading: true,
      loadingDeliveryInfo: false,
      productTotal: 0,
      paymentStep: 0,
      deliveryCost: 0,
      showAddressModal: false,
      deliveryError: false
    };

  }

  async componentDidMount() {
    if (this.props.userId) {
      await this.getAddresses();
      await this.refreshCart();
    }
  }

  async componentDidUpdate(prevProps) {
    const { userId, showShoppingCart } = this.props;

    if (prevProps.userId !== userId || (showShoppingCart && !prevProps.showShoppingCart && userId)) {
      await this.getAddresses();
      await this.refreshCart();
    }
  }

  async getAddresses(added) {
    const addresses = await fetch(`${mainApiUrl}/addresses/user/${this.props.userId}`);
    const res = await addresses.json();

    let selectedAddress = null;
    if (res.length > 0) selectedAddress = res[0];
    if (added) selectedAddress = res[res.length - 1];

    this.setState({ userAddresses: res, selectedAddress }, () => {
      if (added) this.getDeliveryQuotations();
    });
  }

  async getShoppingCartProducts() {

    const { userId, token } = this.props;
    const prom = await fetch(`${apiUrl}/shoppingCart/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        businessName,
        token
      })
    });

    const res = await prom.json();

    if (res.success) {
      const { items } = res;
      const total = items.reduce((a, b) => ({ amount: a.amount + b.amount }), { amount: 0 });

      this.setState({ products: items, productTotal: total.amount });
    }
  }

  async getDeliveryQuotations() {

    const { products, selectedAddress } = this.state;
    const { user, showShoppingCart, token, userId } = this.props;

    if (!selectedAddress || showShoppingCart) return;

    this.setState({ deliveryError: false, loadingDeliveryInfo: true });

    let newDeliveryCost = 0;

    const deliveryProducts = products.filter(product => product.product && product.product.hasDelivery && product.userId);
    const groupedProducts = groupBy(deliveryProducts, 'userId');
    const groupedProductsArray = Object.values(groupedProducts);

    for (let i = 0; i < groupedProductsArray.length; i++) {
      const quotationQuery = await fetch(`${apiUrl}/shoppingCart/delivery/getQuotation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          products: groupedProductsArray[i],
          user,
          selectedAddress,
          token,
          userId,
          businessName
        })
      });

      const quotationRes = await quotationQuery.json();
      const quotationData = quotationRes.data;

      if (quotationData.status === 'OK') {
        try {
          const prodIndex = products.indexOf(groupedProductsArray[i][0]);

          products[prodIndex].idRate = quotationData.data.rates[0].idRate;
          products[prodIndex].destination = selectedAddress;
          products[prodIndex].origin = products[prodIndex].product.deliveryInfo;
          products[prodIndex].quotation = quotationData.data;
          products[prodIndex].deliveryCost = quotationData.data.rates[0].flete + quotationData.data.rates[0].minimumInsurance;
          newDeliveryCost += quotationData.data.rates[0].flete + quotationData.data.rates[0].minimumInsurance;
        } catch (error) {
          console.log(error);
          this.setState({ deliveryError: true });
        }
      } else {
        this.setState({ deliveryError: true });
      }

      // console.log(quotationData);

    }

    this.setState({ products, deliveryCost: newDeliveryCost, loadingDeliveryInfo: false });
  }

  async refreshCart() {
    await this.getShoppingCartProducts();
    this.setState({ isLoading: false });
    await this.getDeliveryQuotations();
  }

  handlePayCart(paymentStep) {
    this.setState({ paymentStep });
  }

  handleChangeAddress = addressValue => {
    this.setState({ selectedAddress: JSON.parse(addressValue), loadingDeliveryInfo: true }, () => this.getDeliveryQuotations());
  };

  render() {

    const {
      products,
      productTotal,
      paymentStep,
      isLoading,
      userAddresses,
      selectedAddress,
      deliveryCost,
      showAddressModal,
      loadingDeliveryInfo,
      deliveryError
    } = this.state;

    const {
      showShoppingCart,
      setShowShoppingCart
    } = this.props;

    const SHOPPING_CART = 'Carrito de compras';

    if (isLoading) {
      return (
        <div style={{ minHeight: '100vh' }} className="centerDiv">
          <Spinner variant="warning" animation="grow" />
        </div>
      );
    }

    if (paymentStep === 1) return (
      <ShoppingCartPayment
        totalAmount={productTotal + deliveryCost}
        deliveryInfo={selectedAddress}
        products={products}
        returnToCart={() => this.handlePayCart(0)}
      />
    );

    return (
      <Container className="shoppingCartSection" style={{ paddingTop: '5%', paddingBottom: '5%' }}>
        <div>
          {
            showShoppingCart &&
            <span className="cartCloseBtn" onClick={() => setShowShoppingCart(false)}>&times;</span>
          }
          <span style={{ fontSize: '28px' }}><strong>{SHOPPING_CART}</strong></span>
        </div>

        <Row>
          <Col sm={showShoppingCart ? 12 : 8}>
            <div style={{ textAlign: 'right', fontSize: '12px' }}>Valor</div>
            <hr />
            {
              products.length === 0 ?
                <div className="center"><h5>¡Carrito de compras vacío!</h5></div> :
                <div>
                  {
                    products.map((product, i) =>
                    (
                      <div key={i}>
                        <ShoppingCartItem
                          item={product}
                          refresh={() => this.refreshCart()}
                        />
                        <hr />
                      </div>
                    )
                    )
                  }
                </div>
            }
            {
              showShoppingCart &&
              <div style={{ textAlign: 'right' }}>
                <h6>Subtotal: COP {formatMoney(productTotal)}</h6>

                <Link to={`/carrito`}>
                  <Button variant="outline-primary" onClick={() => setShowShoppingCart(false)}>
                    Realizar pago
                  </Button>
                </Link>
              </div>
            }
          </Col>
          {
            !showShoppingCart &&
            <Col sm={4}>
              <div className="summaryContainer">
                {
                  products.length > 0 &&
                  <div>
                    <div className="chooseAddressTitle">Elegir dirección de envío</div>
                    <Form.Control
                      as="select"
                      onChange={event => this.handleChangeAddress(event.target.value)}
                      required
                      disabled={loadingDeliveryInfo}
                    >
                      {
                        userAddresses.map((address, i) =>
                          <option key={i} value={JSON.stringify(address)}>{address.short}</option>
                        )
                      }
                    </Form.Control>
                    <div className="center">
                      <Button
                        variant="outline-success"
                        style={{ marginTop: '6px', marginBottom: '6px', height: '30px', fontSize: '12px' }}
                        onClick={() => this.setState({ showAddressModal: true })}
                      >
                        Agregar nueva
                      </Button>
                    </div>
                  </div>
                }

                {
                  selectedAddress && products.length > 0 &&
                  <div className="summaryAddressInfo">{selectedAddress.street + ', ' + selectedAddress.city}</div>
                }
                <br />

                <div>Subtotal: COP {formatMoney(productTotal)}</div>
                <div>Costo de envío: {!loadingDeliveryInfo ? `COP ${formatMoney(deliveryCost)}` : 'Calculando...'}</div>

                {
                  (deliveryError && selectedAddress) &&
                  <div style={{ color: 'red', fontSize: '12px' }}>Error al calcular el costo de envío</div>
                }
                <br />

                <h5>Total: COP {formatMoney(productTotal + deliveryCost)}</h5>

                <Button
                  variant="primary"
                  onClick={() => this.handlePayCart(1)}
                  style={{ width: '100%', marginTop: '16px' }}
                  disabled={
                    loadingDeliveryInfo ||
                    deliveryError ||
                    products.length === 0 ||
                    (products.length > 0 && !selectedAddress)
                  }
                >
                  Realizar pago
                </Button>
                {
                  (products.length > 0 && !selectedAddress) &&
                  <span>Debes seleccionar una dirección de envío.</span>
                }
              </div>
            </Col>
          }
        </Row>

        <Modal show={showAddressModal} onHide={() => this.setState({ showAddressModal: false })} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Agrega una dirección de envío</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddressesComponent
              userId={this.props.user._id}
              refreshAddresses={() => this.getAddresses(true)}
              closeModal={() => this.setState({ showAddressModal: false })}
            />
          </Modal.Body>
        </Modal>
      </Container>
    );
  }
}

const ShoppingCart = connect(select, mapDispatchToProps)(ConnectedShoppingCart);

export default ShoppingCart;
